/**
 * Canonical in-app route map.
 *
 * The Shopify admin sidebar (`<ui-nav-menu>`) cannot nest navigation items, so
 * pages that belong together are grouped under a path prefix and the group's
 * destinations are repeated as an in-page tab row (`SectionNav`). One sidebar
 * entry per prefix keeps the admin highlight correct on every sub-page, which is
 * the whole reason those routes carry a prefix rather than living at the root.
 *
 * Grouping is not free: it costs a click and buries the group's members. So only
 * genuinely peer-level pages get grouped, and headline features stay top-level
 * with a root path (see the ungrouped destinations below).
 *
 * Adding a page to a group means adding it here — `AppNavigation` and every
 * grouped page read this module, so the sidebar and the tab row can't drift.
 */

export interface SectionNavItem {
  label: string;
  /** Route path; also the prefix that marks the item active for its sub-pages. */
  href: string;
}

/** Things the merchant uploads and packages. */
export const CATALOG_SECTION: SectionNavItem[] = [
  { label: 'Tracks', href: '/catalog/tracks' },
  { label: 'Sound kits', href: '/catalog/soundkits' },
  { label: 'Albums', href: '/catalog/albums' },
  { label: 'Tracklists', href: '/catalog/tracklists' },
];

/** How the catalog looks on the storefront. */
export const STOREFRONT_SECTION: SectionNavItem[] = [
  { label: 'Presets', href: '/storefront/presets' },
];

/** Landing route for each sidebar group — the first tab, not a bare hub page. */
export const CATALOG_HOME = CATALOG_SECTION[0].href;
export const STOREFRONT_HOME = STOREFRONT_SECTION[0].href;

/**
 * Ungrouped top-level destinations. Orders and licensing are headline
 * features, so they each own a sidebar entry rather than sharing a "Sales"
 * group — which also means neither carries a section prefix or an in-page
 * tab row.
 */
export const MEDIA_HOME = '/media';
export const ORDERS_HOME = '/orders';
export const LICENSES_HOME = '/licenses';
